"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrefixedSelect = PrefixedSelect;
var _objectSpread2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _prefixedSelectModule = _interopRequireDefault(require("./prefixed-select.module.scss"));
var _Select = require("../../../elements/select/select/Select");
var _filterArrow = require("../../../assets/icons/filter-arrow.svg");
var _reactSelect = require("react-select");
var _excluded = ["prefix", "prefixIcon", "className"];
var DropdownIndicator = function DropdownIndicator(props) {
  return /*#__PURE__*/_react.default.createElement(_reactSelect.components.DropdownIndicator, props, /*#__PURE__*/_react.default.createElement(_filterArrow.ReactComponent, {
    className: _prefixedSelectModule.default['filter-select__arrow']
  }));
};
function PrefixedSelect(_ref) {
  var prefix = _ref.prefix,
    prefixIcon = _ref.prefixIcon,
    className = _ref.className,
    selectProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var formatValue = function formatValue(option) {
    return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, option), {}, {
      label: /*#__PURE__*/_react.default.createElement("span", {
        className: _prefixedSelectModule.default['prefixed-select__selected-value']
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: _prefixedSelectModule.default['prefixed-select__prefix']
      }, prefixIcon, prefix, ":"), ' ', option.label)
    });
  };
  return /*#__PURE__*/_react.default.createElement(_Select.Select, Object.assign({}, selectProps, {
    dropdownIndicator: DropdownIndicator,
    className: (0, _classnames.default)(_prefixedSelectModule.default['prefixed-select'], className),
    formatValue: formatValue
  }));
}